import { ConfirmDialog, LinearProgress, Typography } from '@occc-app/design-system';

type SubmissionGroupRemoveLocationsDialogProps = {
  open: boolean;
  setOpen: (value: boolean) => void;
  onConfirm: () => void;
  isRemoveLocationFromSubmissionGroupInProgress?: boolean;
  selectedCount?: number;
};

export const SubmissionGroupRemoveLocationsDialog = ({
  open,
  setOpen,
  onConfirm,
  isRemoveLocationFromSubmissionGroupInProgress,
  selectedCount = 1,
}: SubmissionGroupRemoveLocationsDialogProps) => (
  <ConfirmDialog
    dialogTitle='Remove Location(s) from Submission Group'
    confirmButtonText='Remove'
    open={open}
    onClose={() => setOpen(false)}
    confirmButtonProps={{
      onClick: onConfirm,
      color: 'error',
      disabled: isRemoveLocationFromSubmissionGroupInProgress,
    }}
  >
    {isRemoveLocationFromSubmissionGroupInProgress && <LinearProgress />}

    <Typography>
      Are you sure you would like to remove{' '}
      {selectedCount === 1 ? 'this Location' : `these ${selectedCount} Locations`} from the
      Submission Group?
    </Typography>
  </ConfirmDialog>
);
